export default __webpack_public_path__ + "static/media/modalnewBack.5ccf5cf3.svg";